((LanguageWidget, $) => {
  'use strict';

  const mobileActiveClass = 'mobile-options-item-active';
  const desktopActiveItemClass = 'desktop-options-item-active';

  let $mobileToggle;
  let $mobileDropdown;
  let $desktopLanguageItem;
  let $mobileLanguageItem;

  const cacheDom = () => {
    $mobileToggle = $('.js-mobile-language-toggle');
    $mobileDropdown = $('.js-mobile-language-list');
    $desktopLanguageItem = $('.js-desktop-langauage-item');
    $mobileLanguageItem = $('.js-mobile-language-item');
  };

  const changeActiveState = ($this, activeClass, $languageItem) => {
    if (!$this.hasClass(activeClass)) {
      $languageItem.removeClass(activeClass);
      $this.addClass(activeClass);
    }
  };

  const clickBinds = () => {
    $mobileToggle.on('click', () => {
      if ($('.js-mobile-currency-list').is(':visible')) {
        $('.js-mobile-currency-list').slideToggle();
      }
      $mobileDropdown.slideToggle();
    });

    $mobileLanguageItem.on('click', function changeMobileActiveState() {
      changeActiveState($(this), mobileActiveClass, $mobileLanguageItem);
    });

    $desktopLanguageItem.on('click', function changeDesktopActiveState() {
      changeActiveState($(this), desktopActiveItemClass, $desktopLanguageItem);
    });
  };

  const bindUIActions = () => {
    clickBinds();
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  LanguageWidget.init = init;
})(window.LanguageWidget = window.LanguageWidget || {}, jQuery);
